import createVueComponent from '../createVueComponent';

const ChevronsUp = createVueComponent('ChevronsUpIcon', [
  ['path', { d: 'm17 11-5-5-5 5', key: 'e8nh98' }],
  ['path', { d: 'm17 18-5-5-5 5', key: '2avn1x' }],
]);

export default ChevronsUp;
